// eslint-disable-next-line
import React, {lazy, Suspense} from "react";
// noinspection ES6CheckImport
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {connect} from 'react-redux';
import {getPublicConfig} from "./services/pub-sys-config";
import AppPrivate from "./app-private";
import Splash from "./components/splash";
import LoadingFullScreen from "./components/loading-full-screen";

// noinspection JSCheckFunctionSignatures
const Login = lazy(() => import('./modules/user-management/login'));
// noinspection JSCheckFunctionSignatures
const AccessDenied = lazy(() => import('./modules/user-management/access-denied'));

class App extends React.Component {
    componentDidMount() {
        document.body.style.margin = 0;
        document.body.style.fontFamily = "open sans, Helvetica Neue, Helvetica, Arial, sans-serif";
    }

    render() {
        const {publicSysConfig} = this.props;
        return (
            !publicSysConfig.length ?
                <Splash/>
                :
                <Suspense fallback={<LoadingFullScreen/>}>
                    <Router>
                        <Switch>
                            <Route exact path="/unauthorized" component={AccessDenied}/>
                            <Route exact path="/dang-nhap" component={Login}/>
                            <AppPrivate/>

                        </Switch>
                    </Router>
                </Suspense>
        );
    }
}

function mapStateToProps(state) {
    return {
        publicSysConfig: state.publicSysConfig,
        auth: state.auth,
        request: state.request,
        recaptcha: state.recaptcha
    }
}

export default connect(mapStateToProps, {getPublicConfig})(App);
